import FaqAnimation from './FaqAnimation';

class FaqListener {
  constructor(element) {
    this.element = element
    this.hash = location.hash
    this.details = [...element.querySelectorAll('details')]
  }
  
  init () {

    for (let details of this.details) {
      new FaqAnimation(details, this.hash)
      
      /*details.addEventListener('toggle', event => {
        if (this.details.some(item => item.open)) {
          this.element.classList.add('details--opened')
        } else {
          this.element.classList.remove('details--opened')
        }
      })*/
    }
  }
  
}

export default FaqListener
